import React, { useEffect, useState } from 'react';
import { get } from 'lodash';

import { AppSkeleton } from '@/component';
import { Button, Input, Textarea } from '@/kaya';
import { authTypes } from '@/types';
import { authHelpers, generalHelpers } from '@/helpers';
import { useArtistStore } from '@/store';
import { userActions } from '@/actions';

import styles from './ContactUs.module.scss';

const ContactUs = () => {
  const { artist } = useArtistStore();
  const [formValues, setFormValues] = useState<authTypes.ContactInfo>(
    authTypes.INITIAL_CONTACT_INFO_VALUES,
  );
  const [err, setErr] = useState({
    // username: '',
    // name: '',
    // email: '',
    // phone: '',
    issue: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (id: string | object) => (value: string | object | boolean | File) => {
    if (typeof id !== 'object') {
      setFormValues({
        ...formValues,
        [id]: value,
      });
      setErr({
        ...err,
        [id]: '',
      });
    } else {
      setFormValues({
        ...formValues,
        ...id,
      });
      setErr({
        ...err,
        ...id,
      });
    }
  };

  const handleSubmit = async () => {
    const error = {
      // username: authHelpers.validateUsername(formValues.username),
      // name: authHelpers.validateName(formValues.name),
      // email: generalHelpers.validateEmail(formValues.email),
      // phone: authHelpers.validatePhone(formValues.phone_no),
      issue: authHelpers.validateDescription(formValues.issue),
    };
    if (!generalHelpers.isEmptyErrors(error)) {
      setErr(error);
      return;
    }
    setLoading(true);
    await userActions.contactUsAction({
      payload: formValues,
    });
    setLoading(false);
  };

  useEffect(() => {
    setFormValues({
      ...formValues,
      username: artist.username,
      name: artist.first_name + ' ' + artist.last_name,
      email: artist.email,
      // phone no is string in artist store then store as it is else convert to string
      phone_no: get(artist, 'phone_no', '').toString(),

      issue: '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artist]);

  const disableButton = () => {
    if (
      formValues.username === artist.username &&
      formValues.name === artist.first_name + ' ' + artist.last_name &&
      formValues.email === artist.email &&
      formValues.phone_no === get(artist, 'phone_no', '').toString() &&
      formValues.issue === ''
    ) {
      return true;
    }
    return false;
  };

  return (
    <AppSkeleton>
      <div className={styles.ContactUs}>
        <h1 className={styles.heading}>Contact Us</h1>
        <div className={styles.box}>
          <div className={styles.labelWithInput}>
            <p className={styles.label}>Username</p>
            <Input
              placeholder="username"
              containerClassName={styles.input}
              onChange={handleChange('username')}
              id="username"
              errors={err}
              value={formValues.username}
              disabled
            />
          </div>
          <div className={styles.labelWithInput}>
            <p className={styles.label}>Name</p>
            <Input
              placeholder="name"
              containerClassName={styles.input}
              onChange={handleChange('name')}
              id="name"
              errors={err}
              value={formValues.name}
              disabled
            />
          </div>
          <div className={styles.labelWithInput}>
            <p className={styles.label}>Email</p>
            <Input
              placeholder="email"
              containerClassName={styles.input}
              onChange={handleChange('email')}
              id="email"
              errors={err}
              value={formValues.email}
              disabled
            />
          </div>
          <div className={styles.labelWithInput}>
            <p className={styles.label}>Phone No.</p>
            <Input
              placeholder="Phone no"
              containerClassName={styles.input}
              onChange={handleChange('phone_no')}
              id="phone_no"
              errors={err}
              value={formValues.phone_no}
              disabled
            />
          </div>
          <div className={styles.labelWithInput1}>
            <p className={styles.label}>Issue</p>
            <Textarea
              placeHolder="Issue"
              onChange={handleChange('issue')}
              error={err.issue}
              className={styles.input}
              value={formValues.issue}
            />
          </div>
          <Button
            onClick={handleSubmit}
            className={styles.btn}
            type="Primary"
            disabled={disableButton()}
            isLoading={loading}
          >
            Send
          </Button>
        </div>
      </div>
    </AppSkeleton>
  );
};

export default ContactUs;
